export default __webpack_public_path__ + "c4b42e4cf9db79e33f3383a7768d7ed6.svg";